// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__j2pN_"};